<template>
  <div class="py-2 px-6" v-if="show">
    <label for="distance_registered" class="block text-sm font-medium leading-6 text-secondary">Km registreret på dag</label>
    <div>
      <input id="distance_registered" v-model="kmUsed" name="distance_registered" type="number" inputmode="numeric"
        class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
      <span class="m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block">Angiv en gyldig Km stand.</span>
    </div>
  </div>
  <div class="py-2 px-6" v-if="show">
    <label for="addressFrom" class="block text-sm font-medium leading-6 text-secondary">Fra adresse</label>
    <div>
      <input id="addressFrom" v-model="addressFrom" name="addressFrom" type="text"
        class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
    </div>
  </div>
  <div class="py-2 px-6" v-if="show">
    <label for="addressTo" class="block text-sm font-medium leading-6 text-secondary">Til adresse</label>
    <div>
      <input id="addressTo" v-model="addressTo" name="addressTo" type="text"
        class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
    </div>
  </div>
</template>

<script lang="ts">
import { TransportType } from '@/models/report.model'
import { defineComponent, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'distance-km-input',
  setup () {
    const store = useStore()
    const kmUsed = ref()
    const addressFrom = ref()
    const addressTo = ref()
    const show = ref(false)
    let timeoutId: number | undefined

    watch(() => store.state.report.currentReport, (currentReport) => {
      kmUsed.value = undefined
      show.value = currentReport && currentReport.state !== 'FREE' && (currentReport.transportType === TransportType.PrivateCar || currentReport.transportType === TransportType.CompanyCar)

      if (currentReport && currentReport.employeeNumber) {
        if (currentReport.kmUsed) {
          kmUsed.value = currentReport.kmUsed
        }
        if (currentReport.addressFrom) {
          addressFrom.value = currentReport.addressFrom
        }
        if (currentReport.addressTo) {
          addressTo.value = currentReport.addressTo
        }
      }
    }, { immediate: true })

    watch(() => store.state.report.currentReport.transportType, (transportType) => {
      if (transportType === TransportType.PrivateCar || transportType === TransportType.CompanyCar) {
        show.value = true
      } else {
        show.value = false
        kmUsed.value = undefined
      }
    }, { immediate: true })

    watch(kmUsed, (newVal: number) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        const valueToCommit = newVal != null ? newVal : undefined
        store.commit('report/UPDATE_REPORT', { key: 'kmUsed', value: valueToCommit })
      }, 300)
    })

    watch(addressFrom, (newVal: number) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        const valueToCommit = newVal != null ? newVal : undefined
        store.commit('report/UPDATE_REPORT', { key: 'addressFrom', value: valueToCommit })
      }, 300)
    })

    watch(addressTo, (newVal: number) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        const valueToCommit = newVal != null ? newVal : undefined
        store.commit('report/UPDATE_REPORT', { key: 'addressTo', value: valueToCommit })
      }, 300)
    })

    return { kmUsed, show, addressFrom, addressTo }
  }
})
</script>
